"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _ListItemSecondaryAction = _interopRequireDefault(require("@material-ui/core/ListItemSecondaryAction"));

var _excluded = ["classes"];

var styles = function styles(theme) {
  return {
    root: {}
  };
};
/**
 * A simple wrapper component to apply secondary action styles to ListItems.
 */


var ListItemSecondaryAction = function ListItemSecondaryAction(props) {
  var classes = props.classes,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = (0, _extends2.default)({
    // See Material UI documentation for available CSS classes can be passed through to override
    root: classes.root
  }, classes);
  return /*#__PURE__*/_react.default.createElement(_ListItemSecondaryAction.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides
  }));
};

ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
ListItemSecondaryAction.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object
}; // If default props are needed, they must be set here
// ListItemSecondaryAction.defaultProps = { };

var _default = (0, _styles.default)(styles)(ListItemSecondaryAction);

exports.default = _default;